import { useLayoutEffect } from 'react';

import { useClickstreamCallback } from '@zenbusiness/application-commons-clickstream';

export default function PageViewedTrackerSync(properties) {
  const { appSection, customDestinationPageName_, experienceOrigin } = properties;

  const pageViewed = useClickstreamCallback('pageViewed', {
    ...properties,
    customDestinationPageName_:
      typeof customDestinationPageName_ === 'string' && customDestinationPageName_ !== ''
        ? customDestinationPageName_
        : `${experienceOrigin} ${appSection}`.toLowerCase()
  });

  // by using useLayoutEffect we ensure that the pageViewed event is triggered sync,
  // useLayouEffect blocks the UI but the pageViewed runs really fast less than 7ms
  useLayoutEffect(() => {
    pageViewed();
    // we only want to trigger this at component mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
